import _ from "lodash";
import { fetchApi } from "../../utils";

const mapField = data => {
  return {
    ...data,
    title: _.get(data, "title"),
    image: _.get(data, "media_image_data.full_file_path"),
    description: _.get(data, "description"),
    video: _.get(data, "desktop_video"),
    imageBanner: _.get(data, "media_desktop_image_data.full_file_path"),
    imageBannerMobile: _.get(data, "media_mobile_image_data.full_file_path")
  };
};

const fetchCareerPageApi = () => {
  return fetchApi("page/career")
    .then(res => _.get(res, "data"))
    .then(mapField);
};

export { fetchCareerPageApi };



// WEBPACK FOOTER //
// ./src/services/page/career.js